import { cfetch } from '@confluence/network';

import { Action, type Suggestion } from '../types/RemoteObject.ts';

type ActionPayload = {
	id: string;
	title: string;
	description?: string;
	url: string;
	parentId: number;
	action: Action.ACCEPT | Action.REJECT;
};

export const useSubmitSuggestionActions = (spaceKey?: string) => {
	const submitActions = (allSuggestions: Suggestion[], selectedIds: Set<string>): void => {
		if (!spaceKey) {
			return;
		}

		const actions: ActionPayload[] = allSuggestions.map((s) => ({
			...s,
			action: selectedIds.has(s.id) ? Action.ACCEPT : Action.REJECT,
		}));

		void cfetch(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/actions`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ actions }),
		});
	};

	return { submitActions };
};
